//package imports
import React, { useEffect, useState, useRef } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { ShareValueDetials,getSharesList } from "../../services/apiServices/GetServices";
import { buySharesApi, getPresignedUrl } from "../../services/apiServices/PostServices";

//component imports
import { useForm } from "react-hook-form";
import { ErrorMessage, Formik, useFormik } from 'formik';
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import FileUpload from "../../utils/resuableComponents/FileUpload";
import { showToast } from "../../utils/constants/Toaster";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageUtils } from "../../utils/imageUtils/ImageUtils";
import Loader from "../loadingScreens/Loader";

const BuyShares = () => {

    const [count, setCount] = useState("")
    const [fileval, setFileVal] = useState("")
    const [preViewFile, setPreViewFile] = useState("")
    const [file, setFile] = useState()
    const [fileSize, setFileSize] = useState(0)
    const [show, setShow] = useState(false);
    const [simpleModal, setSimpleModal] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [checked, setChecked] = useState(false)
    const [initialValues, setInitialValues] = useState({
        message: '',
    });
    const [shareValueDetails, setShareValueDetails] = useState([])
    const [shareData, setShareData] = useState([])
    const [shareAmount, setShareAmount] = useState(0)
    const [messageNote, setMessageNote] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [clicked, setClicked] = useState(false)
    const handleClose = () => setShow(false);
    const closeSimpleModal = () => setSimpleModal(false)
    const handleDeleteModal = () => setDeleteModal(false)
    const [fileUploadReqbody, setFileUploadReqbody] = useState()
    const [fileData, setFileData] = useState()
    const [totalAmountInvested, setTotalAmountInvested] = useState()
    const [totalShares, setTotalShares] = useState(0)
    const [shareType,setShareType]=useState("")
    const [shareTypeValue,setShareTypeValue]=useState(0)
    const [isLoader, setisLoader] = useState(false)
    const history = useHistory();

    const termsAndCondtionPath = process.env.REACT_APP_TERMS_CONDTIONS
    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            checkbox: false,
        },
    });

    useEffect(() => {
        callShareDetailsApi()
        getShareList()
    }, [])

    useEffect(() => {
        if (count !== "" && messageNote !== "" && fileval !== "" && checked === true && shareTypeValue !== 0 && shareAmount !==0) {
            setErrorMessage("")
        }
    }, [errorMessage])

    //function to call share value details
    const callShareDetailsApi = async () => {
        try {
            const res = await ShareValueDetials("osanShares")
            if (res?.success) {
                setShareValueDetails(res?.osanShares)
                setTotalAmountInvested(res?.total_amount)
                setTotalShares(res?.total_shares !== null ? res?.total_shares : 0)

            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }

    }

    //api function call to get the share list
    const getShareList = async () => {
        try {
            const res = await getSharesList("allShare");
            if (res.success) {
                  const filteredData = res?.shares?.filter(data => data?.is_active === 1)
                setShareData(filteredData)
            
            } else {
                console.log("res", res)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    const handleMessageChange = event => {
        let message = event;
        if(event.startsWith(" ")){
             message = ""
       }else{
           message= event
       }
        setMessageNote(message)
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            message: message,
        }));
    };

    //function to handle image uploading file
    const handleImageUpload = async (data) => {

        setFileVal(data?.name)
        setFileSize(data?.size)
        setPreViewFile(URL.createObjectURL(data))

        if (data?.size <= 5 * 1048576) {
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "shares",
                serviceType: "buy"
            };
            setFileUploadReqbody(reqBody)
            setFileData(data)
        } else {
            showToast(3, "Image should be less than 5 mb")
        }
    }

    //function to handle terms & conditon checkebox
    const handleCheck = () => {
        setChecked(!checked)
    }

    //function to handle image delete
    const handleImageDelte = () => {
        setFileVal("")
        setFileSize(0)
        setDeleteModal(false)
        //    window.location.reload()
    }

    //function to handle modal open and close
    const handleShow = () => {
        setShow(true);
    }

    const handleSimpleModal = () => {
        if (count === "" || messageNote === "" || fileval === "" || shareTypeValue === 0 || shareAmount === 0) {
            setErrorMessage("Please enter the required fields above")
        }
        else if (checked === false) {
            setErrorMessage('Please select the check box')
        } else if (fileSize > 5 * 1048576) {
            showToast(3, "Image should be less than 5 mb")
        }
        else if (count !== "" && messageNote !== "" && fileval !== "" && fileSize < 5 * 1048576 && checked === true && shareTypeValue !== 0 && shareAmount !== 0) {
            setErrorMessage("")
            setSimpleModal(true);
            setClicked(false)
        }
    }

    const hanldeDeleteOpen = () => {
        setDeleteModal(true)
    }

    const handleChangeShare = event => {
        const share = event.target.value;
        setShareType(share?.id)
        setShareAmount(0)
        setCount("")
        setShareTypeValue(share?.value)
      
    };

    const validate = values => {
        const errors = {};
        // Validate email
        if (!values.message) {
            errors.message = 'Required'
        }
        return errors;
    };

    //function to handle on click of space submit
    const handleKeyDown = (event) => {
        // Check if the pressed key is the space key and if the submit button is focused
        if (event.key === ' ' || event.key === 'Spacebar') {
            const submitButton = document.activeElement;
            if (submitButton && submitButton.type === 'submit') {
                // Prevent the default action (form submission) when the space key is pressed
                event.preventDefault();
            }
        }
    };

    //function call to hit buy share api
    const handleBuyShareSubmit = async (url) => {
        setisLoader(true)
        try {
            const reqbody = {
                buy_amount: shareAmount,
                image_url: url,
                share_type: shareType,
                message: messageNote
            }
            const res = await buySharesApi("buyShares", reqbody)
            if (res?.success) {
                setCount("")
                setMessageNote("")
                setShareAmount(0)
                setFile([])
                setFileVal("")
                setErrorMessage("")
                setChecked(false)
                setSimpleModal(false)
                history.push("/customerPortal/myShares")
                showToast(1, res?.message)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }

    }

    //funtion call to upload image and trigger share submit.
    const handleSubmitBuy = async () => {

        if (!clicked) {
            setClicked(true)
            try {
                const resUrl = await getPresignedUrl("dataSignUrl", fileUploadReqbody)

                if (resUrl?.success) {
                    ImageUtils.uploadFileToS3(fileData, true, resUrl?.data?.preSignedUrl)
                        .then(res => {
                            if (res?.ok) {
                                setFile(resUrl?.data?.dataUrl)
                            }
                            handleBuyShareSubmit(resUrl?.data?.dataUrl)
                        })
                        .catch(e => {
                            console.log(e);
                        });
                } else {
                    console.log("res", resUrl?.message)
                }
            } catch (error) {
                console.log("error", error)
            }
        }
    }
    const formik = useFormik({
        initialValues: initialValues,
        validate,
        onSubmit: values => {
            console.log(values?.message);
        },
    });
    const handleShareCount = (Share) => {
        const maxLength = 9;
        const truncatedValue = Share.slice(0, maxLength);
        setCount(truncatedValue)

        const totalCost = truncatedValue * shareTypeValue;
        // console.log("total",totalCost)

        if (totalCost === null) {
            showToast(3, "Shares range execessed")
        } else {
            setShareAmount(count === 0 ? 0 : totalCost)
        }
    }

    return (
        <div class="col-md-12 d-flex flex-column  full-height" >
            {
                isLoader ? <Loader /> : null
            }
            <h1 class="fs-4 w-100 border-bottom border-top mb-xxl-5 p-1">
                Buy Share
            </h1>
            <div class="container-fluid sub-height">
                <div class="col-12 d-flex sub-height flex-row justify-content-center align-items-center  mt-xl-0">
                    <div class="d-flex flex-column col-lg-6">
                        <div class="mx-2 my-2">
                            <p class="m-0 colorPrimary text-start"><span class="fw-bold">Note:</span> Minimum investment is ₹ 1 Lakh.</p>
                        </div>
                        <div class="d-flex flex-column align-items-center">
                            <div class="mx-2 my-1">
                                <p class="text-black fw-bold m-0">Follow Steps To Buy Shares:</p>
                                <ul class="paraColor listFontSize w-90">
                                    <li class="roboto"><span class="fw-bold paraColor">Transfer Capital Amount:</span> Transfer the capital amount to the designated bank details provided by Osan Grows.</li>
                                    <li class="roboto"><span class="fw-bold paraColor" >Fill Share Purchase Request Form:</span>  Complete the share purchase request form with all details and a brief message indicating the intention to purchase shares.</li>
                                    <li class="roboto"><span class="fw-bold paraColor" >Attach Payment Screenshot:</span> Attach a screenshot or proof of the payment transaction within the form.</li>
                                    <li class="roboto"><span class="fw-bold paraColor">Submit the Form:</span> Submit the form with all the required details.</li>
                                    <li class="roboto"><span class="fw-bold paraColor">Admin Review:</span> The admin will review your request along with the payment details provided.</li>
                                    <li class="roboto"><span class="fw-bold paraColor">Request Approval:</span> Upon verification, the admin will approve your request for purchasing Osan Shares.</li>
                                </ul>
                            </div>
                            <div class="col-lg-9 d-flex boxBackgroundStyle justify-content-center align-items-center border shadow-sm p-2 my-2">
                                <div class="text-center">
                                    <FontAwesomeIcon icon={faBuildingColumns} style={{ fontSize: "30px", color: "#0A2FB6" }} />
                                    <h6 class="fw-bold fs-5 colorPrimary">Bank Details</h6>
                                    <div class="text-start">
                                        <h6 class="colorPrimary">Account Number : 50200086459972</h6>
                                        <h6 class="colorPrimary">Name : OSAN GROWS LTD</h6>
                                        <h6 class="colorPrimary">IFSC Code : HDFC0000523</h6>
                                        <h6 class="colorPrimary">Branch : RICHMOND ROAD BENGALURU</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <form onKeyDown={handleKeyDown} onSubmit={formik.handleSubmit} autoComplete="off">
                            <div class="d-flex flex-column border shadow border-1  h-100 m-2">
                                <div class="mx-2 my-1 montserrat">
                                    <h5 class="fw-bold m-0" >Submit Request To Buy Shares</h5>
                                </div>

                                <div class="d-flex flex-column  border m-2 ">
                                    <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">

                                        <div class="w-75">
                                            <h6 class="mb-0">Shares type*</h6>
                                        </div>
                                        <div class="w-50 text-center me-3" >
                                        <CustomDropdown data={shareData}
                                                onChange={(e) => {
                                                    handleChangeShare(e)
                                                }}
                                                value={shareType}
                                                fromName="share"
                                               
                                                // error={formik.touched.state && Boolean(formik.errors.state)}
                                                // helperText={formik.touched.state ? formik.errors.state : ''}
                                                height={"35px"}
                                                name="share"
                                            />
                                        </div>
                                    </div>
                                    <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">

                                        <div class="w-50">
                                            <h6 class="mb-0">Shares *</h6>
                                        </div>
                                        <div class="w-50 text-end me-3" >
                                            {/* <i class="bi bi-dash "></i> */}
                                            <input value={count}
                                                type="Number"
                                                onChange={(e) => {
                                                    handleShareCount(e.target.value)
                                                }}
                                                placeholder="0"
                                                maxlength="8"
                                                class="amountStyle shadow"
                                            />
                                            {/* <i class="bi bi-plus"></i> */}
                                        </div>
                                    </div>
                                    <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row ">
                                        <div class="w-50">
                                            <h6 class="mb-0">Approx.Share amount </h6>
                                        </div>
                                        <div class="mx-3 w-25 text-start" >
                                            <h6 class="mb-0 ms-1">₹{isNaN(shareAmount) ? 0 : shareAmount}</h6>
                                        </div>
                                    </div>
                                    <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">
                                        <h6 class="mb-0">Upload Image *</h6>
                                        <div class="mx-2" >
                                            <div class="d-flex flex-row w-100 justify-content-center align-items-center" >
                                                {
                                                    fileval === "" ?
                                                        <FileUpload onClick={handleImageUpload} id={"img"} name={"img"} />
                                                        : null
                                                }

                                                {fileval != "" ?
                                                    <div class="d-flex flex-row" >
                                                        <h6 class="mx-2 paraColor">{fileval}</h6>
                                                        <h6 class=" previewColor text-end mx-2 cursorPointer" onClick={handleShow} >Preview</h6>
                                                        <i class="bi bi-trash" onClick={() => hanldeDeleteOpen()}></i>
                                                    </div>
                                                    :
                                                    ""
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="mx-2">
                                    <CustomTextField
                                        control={control}
                                        header={"Message *"}
                                        name="message"
                                        size="small"
                                        value={messageNote}
                                        placeholder={"Hello there,I would like to talk about how to..."}
                                        multiline={true}
                                        rows={4}
                                        inputProps={{
                                            min: 3,
                                            maxLength: 250,
                                        }}
                                        error={formik.touched.message && Boolean(formik.errors.message)}
                                        helperText={formik.touched.message ? formik.errors.message : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        onChange={(e) => {
                                            const result = e.replace(/\D/g, "");
                                            // setMobileNumber(result);
                                            // setMessage(e)
                                            handleMessageChange(e)
                                        }}
                                    />
                                </div>

                                <div class="d-flex flex-row p-0 my-2 mx-2 form-check align-self-start ">
                                    <div>
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={handleCheck}
                                        />
                                    </div>
                                    <label class="form-check-label mx-2" for="exampleCheck1">I have read & agree to the  <a href={termsAndCondtionPath} class="text-decoration-none previewColor " target="_blank">
                                        <span >Terms & Conditions</span>
                                    </a>   </label>

                                </div>
                                <div class="mx-2">
                                    {
                                        errorMessage !== "" ? <h6 class="text-danger">{errorMessage}</h6> : <h6 class="text-danger">{errorMessage}</h6>
                                    }
                                </div>


                                <div class="my-1 align-self-center mb-4">
                                    <button type="button" onClick={() => handleSimpleModal()} variant="contained" class="primaryButton px-3">
                                        Submit
                                    </button>
                                </div>

                                <CustomModal
                                    close={handleClose}
                                    open={show}
                                    imgvalue={preViewFile}
                                />

                                <CustomModal
                                    close={closeSimpleModal}
                                    open={simpleModal}
                                    modalContent={"Are you sure want to buy the shares?"}
                                    Action={handleSubmitBuy}
                                    disableButton={true}
                                />

                                <CustomModal
                                    close={handleDeleteModal}
                                    open={deleteModal}
                                    Action={handleImageDelte}
                                    modalContent={"Are you sure want to delete the image?"}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuyShares